import Openfort, {
  AuthPlayerResponse,
  ShieldAuthType,
  ThirdPartyOAuthProvider,
  ShieldAuthentication,
  TokenType,
  TypedDataDomain,
  TypedDataField,
  EmbeddedState
} from '@openfort/openfort-js';

import { initializeSingularity } from 'singularity-init';
import { v4 as uuidv4 } from 'uuid';

declare global {
    interface Window {
        SingularityEvent: any;
    }
}

export declare class AccountResponse {
    'id': string;
    // 'object': EntityTypeACCOUNT;
    'createdAt': number;
    'address': string;
    'ownerAddress': string;
    'deployed': boolean;
    'custodial': boolean;
    'embeddedSigner': boolean;
    /**
    * The chain ID.
    */
    'chainId': number;
    'accountType': string;
    'pendingOwnerAddress'?: string;
    // 'transactionIntents'?: Array<PlayerResponseTransactionIntentsInner>;
    // 'player': EntityIdResponse;
    constructor();
}

// const openfortConfig = {
//     publicKey: "pk_test_3865255c-910a-5ce3-8ce2-738c38e80bc2",
//     shieldApiKey: "8715a505-9a6b-40e7-877a-8f2f31f7a0e4", //"e36cc5aa-cf98-4138-bd39-6142e1125b93",
//     shieldEncryptionShare: "rWUfTiTgcoQvM6trjUNL6btJPTI9fNsQaMgDy1MkINY=",
// };

// const openfort = new Openfort(openfortConfig.publicKey, openfortConfig.shieldApiKey, openfortConfig.shieldEncryptionShare);
// const chainId = 97;

var openfort : Openfort;
var chainId : number;
var watchAccount : () => () => void;
var unwatchAccount: () => void;

export const OFGetChainId = () => {
    return chainId;
}
export const OFSetChainId = (_chainId: number, _watchAccount: () => () => void, _unwatchAccount: () => void) => {
    chainId = _chainId;
    watchAccount = _watchAccount;
    unwatchAccount = _unwatchAccount;
    // initPurchaseOasToken();
}

export const OFGetOpenfort = () => {
    return openfort;
}

export const OFInitialize = (publicKey: string, shieldApiKey: string, shieldEncryptionShare: string) => {
    console.log({publicKey});
    console.log({shieldApiKey});
    console.log({shieldEncryptionShare});

    openfort = new Openfort({
        baseConfiguration: {
            publishableKey: publicKey,
        },
        shieldConfiguration: {
            shieldPublishableKey: shieldApiKey,
            shieldEncryptionKey: shieldEncryptionShare,
            debug: true,
        }
    });
    return openfort;
}

export const OFauthenticateWithThirdPartyProvider = async(identityToken: string): Promise<AuthPlayerResponse> => {
    try {
        console.log({identityToken});
        console.log({openfort});
        return await openfort.authenticateWithThirdPartyProvider({
            provider: ThirdPartyOAuthProvider.FIREBASE,
            token: identityToken,
            tokenType: TokenType.ID_TOKEN,
        });
    } catch (error) {
        console.error('Error authenticating with Openfort:', error);
        throw error;
    }
}

export const OFgetEmbeddedState = () => {
    try {
        const embeddedState = openfort.getEmbeddedState();
        console.log(embeddedState === EmbeddedState.EMBEDDED_SIGNER_NOT_CONFIGURED ? ("EMBEDDED_SIGNER_NOT_CONFIGURED") : (
            embeddedState === EmbeddedState.CREATING_ACCOUNT ? ("CREATING_ACCOUNT") : (
                embeddedState === EmbeddedState.READY ? ("READY") : (
                    "ELSE"
                )
            )
        ));
        return embeddedState;
    } catch (error) {
        console.error('Error retrieving embedded state from Openfort:', error);
        throw error;
    }
}

export const OFsignMessage = async (message: string): Promise<string | null> => {
    try {
        return await openfort.signMessage(message);
    } catch (error) {
        console.error("Error:", error);
        return null
    }
}

export const OFsignTypedData = async (domain: TypedDataDomain, types: Record<string, Array<TypedDataField>>, value: Record<string, any>): Promise<string | null> => {
    try {
        return await openfort.signTypedData(domain, types, value);
    } catch (error) {
        console.error("Error:", error);
        return null
    }
}

export const OFsetAutomaticRecoveryMethod = async (identityToken: string) => {
    try {
        console.log("=====----->>>>>", "setAutomaticRecoveryMethod", 
            identityToken.slice(0, 5) + '...' + identityToken.slice(-5));
        const shieldAuth: ShieldAuthentication = {
            auth: ShieldAuthType.OPENFORT,
            token: identityToken,
            authProvider: "firebase",
            tokenType: "idToken",
        };
        await openfort.configureEmbeddedSigner(chainId, shieldAuth);
    } catch (error) {
        console.error('Error authenticating with Openfort:', error);
        throw error;
    }
}

export const OFlogout = async () => {
    try {
        await openfort.logout();
    } catch (error) {
        console.error('Error logging out with Openfort:', error);
        throw error;
    }
}

export const OFsendTransaction = async (transactionIntent: any): Promise<any | null> => {
    try {
        console.log("----->>>>>", "sendTransaction()", transactionIntent.nextAction);
        if (transactionIntent && transactionIntent.nextAction) {
            const response = await openfort.sendSignatureTransactionIntentRequest(
                transactionIntent.id,
                transactionIntent.nextAction.payload.userOperationHash
            );
            console.log({response});

            return response;
        } else {
            // return null;
            // 이 단계까지 올 수 없어야 한다.
            throw new Error("Transaction Intent Invalid");
        }
    } catch (error: any) {
        // return null
        console.error('Error call Send Transaction API:', error);
        console.error({error});
        if (error.message) {            
            throw error.message;
        }
        throw error;
    }
}

export const OpenRamp = async (
    userAddress: string,
    eventHandler: (type: string, data: string) => void
): Promise<any | null> => {
    try {
        await waitForSingularityEvent();
        SetEventHandler(eventHandler)
        return await OnRampHandler(userAddress);

    } catch (error: any) {
        // return null
        console.error('Error Open Ramp SDK:', error);
        console.error({error});
        if (error.message) {            
            throw error.message;
        }
        throw error;
    }
}

var lastRequestString = '';

const OnRampHandler = async (toAddr: string, amount: string = '200') => {
    console.log('OnRampHandler', toAddr, amount);
    const clientReferenceId = uuidv4(); //Your internal transaction reference ID

    await window.SingularityEvent.loginWithProvider(window.ethereum) // here etherum is the provider instance
    const userData = await window.SingularityEvent.getConnectUserInfo()
    console.log('userData', toAddr, {userData})
    // 만약 userData가 없다면 에러처리해야 할듯
    
    const body = {
        clientReferenceId: clientReferenceId,
        singularityTransactionType: 'RECEIVE',
        transactionLabel: 'Kingdom Purchase', // Short description of transaction (e.g. "Eth purchase". This will be shown to the user during payment flow.
        transactionDescription: 'KSHW Purchase OAS Token', // Long description of transaction, if different from label
        // transactionIconLink:
        //     '<URL_of_transaction_image_to_be_shown_to_the_user>', // Any public url of png or jpg image. This will be shown to the user during payment flow.
        clientReceiveObject: {
            clientRequestedAssetId: '72258780', //This is Singularity's internal ID for the particular token that the user wants to purchase. Get the full list of IDs for your app by contacting us.
            clientRequestedAssetQuantity: amount, // The number of tokens the user wants to purchase
            address: toAddr, // This field points to who will receive the asset. if the field is not provided, the asset will be transferred to your (merchant's) registered address, instead of the user's.
        },
        // optionalAssets: ['7225878', '247253'] // Optionally, add other tokens that the user can purchase from a drop down menu that will appear during payment
    };

    console.log({ body });

    const requestString = JSON.stringify(body);
    lastRequestString = requestString;
    if (EventHandler && typeof EventHandler === 'function')
    {
        EventHandler('request', requestString);
    }

    window.SingularityEvent.transactionFlow(requestString);
};

const waitForSingularityEvent = () => {
    return new Promise<void>((resolve) => {
        const intervalId = setInterval(() => {
            if (
                window.SingularityEvent &&
                typeof window.SingularityEvent.transactionFlow ===
                    'function'
            ) {
                clearInterval(intervalId); // `SingularityEvent` 以鍮꾨릺硫??명꽣踰?硫덉땄
                resolve(); // 珥덇린?붽? ?꾨즺?섏뿀?쇰?濡?Promise ?닿껐
            } else {
                console.log(
                    'SingularityEvent is not initialized. Retrying...'
                );
            }
        }, 1000); // 1珥덈쭏???뺤씤
    });
};

var EventHandler: any;

function SetEventHandler(newHandler?: (type: string, data: string) => void) {
    EventHandler = newHandler;
}


const initPurchaseOasToken = async () => {
    const apiKey = 'js5BuDFwpiFslSi3W05wpmGW7IhwehDC';
    initializeSingularity(
        window,
        document,
        'latest',
        'production',
        apiKey,
        async () => {
            console.log('initializeSingularity callback');
            // 이때 구매버튼 활성화 및 콜백 이벤트 등록
            SetEventHandler();
            window.SingularityEvent.subscribe(
                'SingularityEvent-logout',
                () => {
                    console.log('logout event received');
                    // navigate('/');
                    window.SingularityEvent.close();
                }
            );

            window.SingularityEvent.subscribe('SingularityEvent-open', () =>
            // setDrawerOpen(true)
            {
                console.log('subscribe open drawer ');
                if (unwatchAccount && typeof unwatchAccount === 'function')
                {
                    unwatchAccount();
                }
            }
            );

            window.SingularityEvent.subscribe(
                'SingularityEvent-close',
                () => {
                    console.log('subscribe close drawer ');
                    if (EventHandler && typeof EventHandler === 'function')
                    {
                        EventHandler('closed', lastRequestString)
                    }
                    if (watchAccount && typeof watchAccount === 'function')
                    {
                        unwatchAccount = watchAccount();
                    }
                }
            );

            window.SingularityEvent.subscribe(
                'SingularityEvent-onTransactionApproval',
                async (data: any) => {
                    console.log('Txn approved', JSON.parse(data));
                    if (EventHandler && typeof EventHandler === 'function')
                        EventHandler('approved', data)
                }
            );
            window.SingularityEvent.subscribe(
                'SingularityEvent-onTokenExpired',
                (data: any) => {
                    console.log('Token expired', JSON.parse(data));
                }
            );
            window.SingularityEvent.subscribe(
                'SingularityEvent-onTransactionSuccess',
                async (data: any) => {
                    console.log('Txn Successfull', JSON.parse(data));
                    if (EventHandler && typeof EventHandler === 'function')
                        EventHandler('success', data);
                }
            );
            window.SingularityEvent.subscribe(
                'SingularityEvent-onTransactionFailure',
                async (data: any) => {
                    console.log('Txn failed', JSON.parse(data));
                    if (EventHandler && typeof EventHandler === 'function')
                        EventHandler('fail', data);
                }
            );

            window.SingularityEvent.subscribe(
                'SingularityEvent-login',
                (data: any) => {
                    console.log('login data --->', data);
                    // checkLoginAndAction()
                }
            );
        }
    );
};